import { useStore } from '@/hooks/useStore';
import { observer } from 'mobx-react-lite';
import { useState } from 'react';
import { ArrowLeft } from 'lucide-react';
import { Input } from '@/components/common/Input';
import CheckboxComponent from '@/components/common/CheckBox';
import { Button } from '@/components/common/Button';
import bannerImg from '@/assets/images/pngs/banner-login.png';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';
import { ROUTES, TYPE_ACCOUNT } from '@/configs/constants';
import { SignUpRequest } from '@/types/http-payload/auth';
import { flowResult } from 'mobx';
import { saveLocalStorage } from '@/utils/browsers';

export default observer(function FinishSignUpPage() {
    // store
    const {
        authStore: { signUp }
    } = useStore();
    const { t } = useTranslation();
    const navigate = useNavigate();
    const location = useLocation();
    const { email, type, twitter_id, line_token, expectedChallenge, dataRegistration } = location.state || {};
    const [agree, setAgree] = useState<boolean>(false);
    const [userName, setUserName] = useState<string>('');

    const handleLogin = () => {
        navigate(ROUTES.login.href);
    };
    const goBack = () => {
        navigate(ROUTES.signUp.href);
    };

    const gotoTermsOfService = () => {
        navigate(ROUTES.termsOfService.href);
    };

    const gotoPrivacyPolicy = () => {
        navigate(ROUTES.privacyPolicy.href);
    };

    const handleSubmit = async () => {
        if (!userName) {

        } else {
            let body: SignUpRequest = {
                type: type,
                username: userName
            };
            if (type === TYPE_ACCOUNT.GOOGLE) {
                body = {
                    ...body,
                    email: email
                };
            } else if (type === TYPE_ACCOUNT.TWITTER) {
                body = {
                    ...body,
                    twitter_id: twitter_id
                };
            } else if (type === TYPE_ACCOUNT.LINE) {
                body = {
                    ...body,
                    line_token: line_token
                };
            } else if (type === TYPE_ACCOUNT.PASSKEY) {
                body = {
                    ...body,
                    email: email,
                    expectedChallenge: expectedChallenge,
                    body: dataRegistration
                };
            }

            const res = await flowResult(signUp(body));
            if (res) {
                if (type === TYPE_ACCOUNT.PASSKEY) {
                    saveLocalStorage('email_passkey', email);
                }
                navigate(ROUTES.home.href);
            }
        }
    };

    return (

        <div className='w-screen h-screen bg-white'>
            <div className='mx-auto flex w-full h-full flex-col justify-start items-center'>
                <ArrowLeft onClick={goBack} size={24} className='absolute top-[24px] left-[24px] text-white cursor-pointer' />
                <img src={bannerImg} alt='bannerImg' className='w-full h-[30%]' />
                <div className='w-full text-center px-[32px] mt-[-32px] rounded-t-[24px] bg-white pt-[32px] space-y-[24px]'>
                    <p className='text-[24px] font-bold'>{t('text.createUsername')}</p>
                    <p className='text-[15px] font-normal'>{t('text.inputUsernameDes')}</p>
                    <Input
                        placeholder={t('text.holderUsername')}
                        className='h-[48px] w-full'
                        value={userName}
                        onChange={(e: React.ChangeEvent<HTMLInputElement>) => setUserName(e.target.value)}
                    />
                    <div>
                        <CheckboxComponent
                            contentLabel={() => (
                                <p className='text-left w-full text-[15px]'>
                                    <span className='text-textBlue cursor-pointer' onClick={gotoTermsOfService}>
                                        {' '}
                                        {t('text.termsOfUser')}
                                        {' '}
                                    </span>
                                    {t('text.and')}
                                    <span className='text-textBlue cursor-pointer' onClick={gotoPrivacyPolicy}>
                                        {' '}
                                        {t('text.privacyPolicy')}
                                    </span>
                                    {t('text.iAgreeToThe')}
                                    <span className='text-textRed'>*</span>
                                </p>
                            )}
                            onCheckedChange={value => setAgree(value)}
                        />
                    </div>
                    <Button
                        variant='main'
                        className='w-full h-[48px] rounded-[10px]'
                        disabled={!agree}
                        onClick={handleSubmit}
                    >
                        {t('text.continue')}
                    </Button>
                </div>
                <div className=' w-full flex justify-center items-center font-semibold pt-[24px] px-[32px]'>
                    <div className='border-t-[1px] border-borderGray pt-[24px] w-full text-center'>
                        <p className='text-black'>{t('messages.have_account')}</p>
                        <p onClick={handleLogin} className='ml-[4px] text-textBlue cursor-pointer'>{t('words_title.sign_in')}</p>
                    </div>
                </div>

            </div>
        </div>
    );
});
